export const qualityMaintenanceScheduleFields = [{
        name: "description",
        title: "Descrizione",
        render: (record) => record.description
    }, {
        name: "schedule",
        title: "Scadenza",
        render: (record) => record.schedule
    }, {
        name: "internal",
        title: "Interna/Esterna",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.internal == 1 ? "INT" : "EST"
    }];
